export type EstadiaAccess = {
  viewManagement?: boolean;
  viewStays?: boolean;
  viewBilling?: boolean;
  validate: boolean;
  rejectValidation: boolean;
  createInvoice: boolean;
  viewInvoices: boolean;
  approveInvoice: boolean;
  rejectInvoice: boolean;
  dispatch: boolean;
};

export const READ_ONLY_ACCESS: EstadiaAccess = {
  validate: false,
  rejectValidation: false,
  createInvoice: false,
  viewInvoices: false,
  approveInvoice: false,
  rejectInvoice: false,
  dispatch: false,
};
